import * as React from 'react';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';

interface ZoomSliderProps {
    zoomLevel: number;
    onDragSlider: (e) => void;
    isKeyboardShortcutVisible: boolean;
}

export const ZoomSlider = (props: ZoomSliderProps) => {
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.blur();
        props.onDragSlider(e);
    }

    return (
        <>
            <KeyboardShortcutTooltip key="zKeyTooltip" show={props.isKeyboardShortcutVisible} keyName="X" />
                <div key="zoomLevelSliderContainer" className="col-md-10">
                    <input
                        id="zoomLevelSlider"
                        type="range"
                        step="1"
                        min="0"
                        max="10"
                        value={props.zoomLevel}
                        list="steplist"
                        onChange={handleOnChange} />
                    <datalist key="steplist" id="steplist">
                        <option key={0}>0</option>
                        <option key={1}>1</option>
                        <option key={2}>2</option>
                        <option key={3}>3</option>
                        <option key={4}>4</option>
                        <option key={5}>5</option>
                        <option key={6}>6</option>
                        <option key={7}>7</option>
                        <option key={8}>8</option>
                        <option key={9}>9</option>
                        <option key={10}>10</option>
                    </datalist>
                </div>
            <KeyboardShortcutTooltip key="xKeyTooltip" show={props.isKeyboardShortcutVisible} keyName="Z" />
        </>
    );
}
